import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { useTimeline } from '../../../hooks/timeline/useTimeline';
import LoadMoreButton from '../../LoadMoreButton/LoadMoreButton';
import { TimelineEntry } from '../TimelineEntry/TimelineEntry';

export const Timeline: FunctionComponent = () => {
  const { timeline, fetchMoreLoading, fetchNextPage } = useTimeline();

  const { t } = useTranslation('common', { useSuspense: false });

  if (!timeline) return null;

  const { nodes = [], pageInfo } = timeline;
  const { hasNextPage } = pageInfo;

  const handleFetchNextPage = async () => {
    const after = pageInfo.endCursor;

    if (!after) return;

    await fetchNextPage(after);
  };

  return (
    <div data-qa="timeline">
      {nodes.map(timelineEntry => {
        return (
          <TimelineEntry
            key={timelineEntry.id}
            fitnessActivity={timelineEntry.fitnessActivity}
            id={timelineEntry.id}
            refreshRequestedTime={timelineEntry.refreshRequestedTime}
            createdAt={timelineEntry.createdAt}
            media={timelineEntry.media}
            message={timelineEntry.message}
            publishingSource={timelineEntry.publishingSource}
          />
        );
      })}
      {hasNextPage && (
        <LoadMoreButton
          loading={fetchMoreLoading}
          onClick={handleFetchNextPage}
          trackingData={{
            action_name: 'click',
            subtype: 'button',
            event: 'click',
            event_value: 'show more',
            sub_section: 'timeline',
          }}
        >
          {t('common.showMore', 'Show more')}
        </LoadMoreButton>
      )}
    </div>
  );
};
